export const convertCsvToJson = file => {
  let csvtojson = require('csvtojson');
  return csvtojson.csv().fromString(file);
};
